/**
 * Display string for an org's LinkedIn "company size". Prefers the normalized
 * headcount range bucket (e.g. "51-200", "10001+") and falls back to the exact
 * employee count with thousands separators (e.g. "1,234").
 *
 * Returns null when neither is known. A non-positive count is treated as unknown
 * (not "0"), mirroring how `formatAum` treats a non-positive AUM.
 */
export function formatCompanySize(
  count: number | null | undefined,
  range: string | null | undefined,
): string | null {
  if (range != null && range !== '') return range;
  if (count != null && count > 0) return count.toLocaleString('en-US');
  return null;
}
